// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"HeaderUserDropdown_dropdown__aWf7O","avatarLarge":"HeaderUserDropdown_avatarLarge__S5XjO","option":"HeaderUserDropdown_option__10PVr"};